import { create } from "zustand";

/**
 * Подтверждение менеджером (ТЗ 04 §2.1): клиент получил APPROVAL_REQUIRED → окно PIN менеджера (ApprovalHost) →
 * токен → повтор запроса с X-Approval-Token. null — пользователь отменил.
 */
export type ApprovalRequest = { action: string; entityId: string | null; value: number; limit: number | null };
type State = { req: (ApprovalRequest & { resolve: (token: string | null) => void }) | null };

export const useApprovalStore = create<State>(() => ({ req: null }));

export function requestApproval(details: Record<string, unknown> | undefined): Promise<string | null> {
  if (!details?.approvalType) return Promise.resolve(null);
  // Одно окно за раз: предыдущий запрос отменяется
  useApprovalStore.getState().req?.resolve(null);
  return new Promise((resolve) =>
    useApprovalStore.setState({
      req: {
        action: String(details.approvalType), entityId: (details.entityId as string | null | undefined) ?? null, value: Number(details.value ?? 0),
        limit: details.limit === null || details.limit === undefined ? null : Number(details.limit),
        resolve: (token) => { useApprovalStore.setState({ req: null }); resolve(token); },
      },
    }),
  );
}
